module.exports = __webpack_public_path__ + "static/media/caneta-desenhando-icon.d38fe87b.svg";